import type { CarouselNavigationProps, CarouselPaginationProps, CarouselProps } from '@ori/presentation-components';

export const BANNERS_CAROUSEL = 'top-area-banners-carousel';
export const navigation: CarouselNavigationProps = { showArrows: false };
export const pagination: CarouselPaginationProps = { show: false };
export const slider: CarouselProps['slider'] = { drag: false };
